import { render, staticRenderFns } from "./applyAssign.vue?vue&type=template&id=a5266fde&scoped=true&"
import script from "./applyAssign.vue?vue&type=script&lang=js&"
export * from "./applyAssign.vue?vue&type=script&lang=js&"
import style0 from "./applyAssign.vue?vue&type=style&index=0&id=a5266fde&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5266fde",
  null
  
)

export default component.exports